import { MxCostCalculator } from "./../mx/mx-cost-calculator.component";
import { Video } from "./components/video.component";
import { Quote } from "./components/quote.component";
import { Info } from "./components/info.component";
import { Hint } from "./components/hint.component";
import * as generalComponents from "./components/general.components";

export const MDX_COMPONENTS = {
  MxCostCalculator,
  Video,
  Quote,
  Info,
  Hint,
  ...generalComponents,
};
